import { BasicCommand } from "~app/common/services/cqs/BasicCommand";

export abstract class DestineraArbetsorderHandelssortimentBaseCommand extends BasicCommand<DestineraArbetsorderHandelssortimentBaseCommand> {
    arbetsorderId: number;
    destineringId: number;
    andel?: number;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "DestineraArbetsorderHandelssortiment";
    get primaryKey(): IArbetsorderHandelssortimentDestineringPrimaryKey {
        return {
            arbetsorderId: this.arbetsorderId,
            destineringId: this.destineringId
        };
    }

    constructor($type, commandType) {
        super($type, DestineraArbetsorderHandelssortimentBaseCommand.$groupKey, commandType);
    }
}

export interface IArbetsorderHandelssortimentDestineringPrimaryKey {
    arbetsorderId: number;
    destineringId: number;
}
